import { hotComments } from '@/mocks/site';

export default function CommentsWall() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
        <div>
          <div className="mb-6 flex items-end justify-between">
            <div>
              <h2 className="font-display text-2xl text-ink md:text-3xl">同学热评墙</h2>
              <p className="mt-1 text-sm text-ink-600">这里最不缺的就是「笑死」和「泪目」</p>
            </div>
            <span className="hidden items-center gap-1 text-sm text-ink-600 sm:flex">
              <i className="ri-arrow-right-up-line text-primary-500" /> 实时更新
            </span>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {hotComments.map((c) => (
              <figure key={c.nickname} className="rounded-xl border border-cream-200 bg-white p-5">
                <figcaption className="flex items-center gap-3">
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-cream-50 ${c.avatarHue}`}>
                    <i className="ri-user-3-line text-lg" />
                  </span>
                  <div>
                    <p className="text-sm font-bold text-ink">{c.nickname}</p>
                    <p className="text-xs text-ink-600">{c.role}</p>
                  </div>
                </figcaption>
                <blockquote className="mt-3 text-sm leading-relaxed text-ink-600">
                  “{c.text}”
                </blockquote>
                <div className="mt-3 flex items-center gap-2 text-xs text-ink-600">
                  <button type="button" className="flex items-center gap-1 rounded-full bg-cream-100 px-2.5 py-1 hover:bg-secondary-100" aria-label="点赞">
                    <i className="ri-heart-3-line text-secondary-500" />
                    {c.likes >= 1000 ? `${(c.likes / 1000).toFixed(1)}k` : c.likes}
                  </button>
                  <span>同学认证</span>
                </div>
              </figure>
            ))}
          </div>
        </div>

        <aside className="flex flex-col justify-between rounded-2xl bg-primary-500 p-6 text-cream-50">
          <div>
            <i className="ri-medal-2-fill text-4xl" />
            <p className="mt-4 text-2xl font-bold">4.9</p>
            <p className="text-sm text-cream-100">全网同学综合好评</p>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-cream-100">
            「校园爆点」累计收到 <b className="text-cream-50">1.2w+</b> 条走心热评。我们把每一个「这也太好笑了」和「看哭了」
            都认真收进周刊，陪你度过每一个想上热搜的校园日常。
          </p>
        </aside>
      </div>
    </section>
  );
}